import { useMemo } from 'react';
import { useGetLmsLookupTranslationsQuery } from '../../../api';

// LMS lookup grubunu (VEHICLE_MODEL, TRAINING_TYPES, TRAINING_LOCATION vb.) sorgular, {value,label} seçenek listesine çevirir.
const useLmsCodeOptions = (groupCode, queryOptions) => {
    const { data, isLoading, isFetching } = useGetLmsLookupTranslationsQuery({ groupCode, isActive: 1, pageNumber: 1, pageSize: 100 }, queryOptions);

    const options = useMemo(() => (data?.items || []).map((item) => ({ value: item.code, label: item.text })), [data]);

    return { data, options, isLoading, isFetching };
};

export default useLmsCodeOptions;
